import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { userActions } from '../../../../redux/actions/user'
import Box from '../../../Shared/Box'
import DefaultLayout from '../../DefaultLayout'
import Loader from '../../../Shared/Loader'
import PropTypes from 'prop-types'
import { withRouter } from '../../../Shared/Routing/withRouter'

class ThirdPartyAuthLandingPage extends PureComponent {

  state = {
    initialized: false,
  }

  componentDidMount () {
    this.login()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      prevProps.router !== this.props.router
    ) {
      this.login()
    }
  }

  login () {
    if (this.state.initialized) {
      return
    }
    const query = new URLSearchParams(this.props.router.location.search);
    const supplierId = this.props.router.params.supplierId
    const code = this.props.router.params.code
    let email = null;
    if(query.has('email')) {
      email = query.get('email')
    }
    this.props.loginSupplier(supplierId,code,email)
    this.setState({ initialized: true })
  }

  render () {
    return (
      <DefaultLayout>
        <div className="page page-third-party-auth-landing-page">
          <Box>
            {this.props.loggingIn ? <Loader size={40}/> : null}
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.user.loggedIn,
    loggingIn: !!state.user.loggingIn,
  }
}

const mapDispatchToProps = {
  loginSupplier: userActions.loginSupplier
}

ThirdPartyAuthLandingPage.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  loggingIn: PropTypes.bool.isRequired,
  loginSupplier: PropTypes.func.isRequired,
  router: PropTypes.object
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThirdPartyAuthLandingPage))
